import "./Maestra.css";
import React, { useEffect, useState, useCallback } from "react";
import { Modal, Button, Form } from "react-bootstrap";

import Sec from "../../static/Logo-SEC.jpg";
import Bios from "./forms/Bios";

import SeccionComentarios from "./subcomponents/SeccionComentarios";
import SeccionDocumentos from "./subcomponents/SeccionDocumentos";
import SeccionGeneral from "./subcomponents/SeccionGeneral";
import SeccionLaboral from "./subcomponents/SeccionLaboral";
import SeccionProgramas from "./subcomponents/SeccionProgramas";
import LoadingOverlay from "../0. Utilidades/LoadingOverlay";

import { BsFillPersonLinesFill } from "react-icons/bs";
import { MdWork } from "react-icons/md";
import { HiMiniAcademicCap } from "react-icons/hi2";
import { SlDocs } from "react-icons/sl";
import { GoCommentDiscussion } from "react-icons/go";
import { CiEdit } from "react-icons/ci";

function MaestraView({ maestra }) {
  const [isLoading, setIsLoading] = useState(true);
  const [maestraData, setMaestraData] = useState(null);
  const [activeTab, setActiveTab] = useState("info");
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [allWhatsappGroups, setAllWhatsappGroups] = useState([]);
  const [selectedGroupIds, setSelectedGroupIds] = useState(new Set());
  const [savingWhatsappGroups, setSavingWhatsappGroups] = useState(false);
  const [whatsappError, setWhatsappError] = useState(null);

  const fetchCSRFToken = useCallback(async () => {
    const url = `${process.env.REACT_APP_BASE_API}api/csrf_token/`;
    const response = await fetch(url, { credentials: "include" });
    const data = await response.json();
    return data.csrfToken;
  }, []);

  const fetchMaestra = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/todas/${maestra.rut}/`,
      );
      if (!response.ok) {
        throw new Error("RUT not found");
      }
      const data = await response.json();
      setMaestraData(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  }, [maestra.rut]);

  useEffect(() => {
    setMaestraData(maestra);
    setIsLoading(false);
  }, [maestra]);

  useEffect(() => {
    // Check the hash in the URL and set the active tab
    const hash = window.location.hash.substring(1); // Remove the '#' character
    if (hash) {
      setActiveTab(hash);
    }
  }, []);

  useEffect(() => {
    // Update the active tab if the URL hash changes
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      setActiveTab(hash || "info");
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  if (isLoading) return <LoadingOverlay />;

    const openWhatsappModal = async () => {
    try {
      setWhatsappError(null);

      const currentIds = new Set(
        (maestraData?.grupos_whatsapp || [])
          .map((g) => g?.id)
          .filter(Boolean)
      );
      setSelectedGroupIds(currentIds);

      const resp = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/whatsapp_grupos/`,
        { credentials: "include" }
      );
      if (!resp.ok) throw new Error("Failed to load whatsapp groups");

      const data = await resp.json();
      setAllWhatsappGroups(Array.isArray(data) ? data : []);
      setShowWhatsappModal(true);
    } catch (e) {
      setWhatsappError("Could not load WhatsApp groups.");
    }
  };

  const closeWhatsappModal = () => {
    if (savingWhatsappGroups) return;
    setShowWhatsappModal(false);
  };

  const toggleWhatsappGroup = (groupId) => {
    setSelectedGroupIds((prev) => {
      const next = new Set(prev);
      if (next.has(groupId)) next.delete(groupId);
      else next.add(groupId);
      return next;
    });
  };

  const saveWhatsappGroups = async () => {
    if (!maestraData?.rut) return;

    setSavingWhatsappGroups(true);
    setWhatsappError(null);

    try {
      const csrfToken = await fetchCSRFToken();
      const url = `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestraData.rut}/whatsapp_grupos/`;

      const resp = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({
          group_ids: Array.from(selectedGroupIds),
        }),
      });

      const data = await resp.json();

      if (!resp.ok) {
        setWhatsappError(data?.error || "Error saving WhatsApp groups.");
        return;
      }

      // Update parent state immediately
      setMaestraData(data);
      setShowWhatsappModal(false);
    } catch (e) {
      setWhatsappError("Network error saving WhatsApp groups.");
    } finally {
      setSavingWhatsappGroups(false);
    }
  };


  return (
    <div id="maestra">
      <div className="maestra-card">
        <div className="maestra-card-container">
          <img
            src={
              maestraData.imagen ||
              "https://cdn-redmaestra-endpoint.azureedge.net/static/images/default.png"
            }
            alt={maestra.nombre || "Default"}
            className="maestra-card-image"
          />
          {maestraData.sec && (
            <img
              src={Sec}
              alt="SEC Certification"
              className="maestra-card-sec"
            />
          )}
        </div>

        <div className="maestra-card-text">
          <p>
            <strong>Nombre:</strong> {maestraData.nombre}
          </p>
          <p>
            <strong>Oficio:</strong> {maestraData.oficio}
          </p>
          <p>
            <strong>Celular:</strong>
            <a href={`tel:${maestraData.celular}`}> +56{maestraData.celular}</a>
          </p>
          <p>
            <strong>Correo:</strong>
            <a href={`mailto:${maestraData.correo}`}> {maestraData.correo}</a>
          </p>
        </div>

        <div className="maestra-card-text">
          <a
            href={`/api/perfiles/editar_maestras/${maestraData.rut}/`}
            className="btn btn-secondary"
          >
            <CiEdit />
          </a>
        </div>
      </div>

      <div className="maestra-bios">
  <div id="maestra-badge" className="w-100">
    <div className="table-responsive">
      <table className="table table-sm table-bordered mb-0">
        <thead>
  <tr>
    <th style={{ width: "1%" }}>#</th>
    <th>Grupos de WhatsApp</th>
    <th style={{ width: "1%", textAlign: "center" }}>
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={openWhatsappModal}
        title="Editar grupos"
      >
        <CiEdit />
      </button>
    </th>
  </tr>
</thead>

        <tbody>
          {Array.isArray(maestraData?.grupos_whatsapp) &&
          maestraData.grupos_whatsapp.length > 0 ? (
            maestraData.grupos_whatsapp.map((g, idx) => (
              <tr key={g.id ?? `${g.nombre}-${idx}`}>
                <td>{idx + 1}</td>
                <td>{g.nombre}</td>
                <td />
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="text-muted">
                No pertenece a un grupo de Whatsapp.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>


      <div className="maestra-bios">
        <Bios
          maestraRut={maestraData.rut}
          bios={maestraData.bios}
          tipo={maestraData.tipo}
          relacion={maestraData.e_relacion}
          onBiosUpdate={fetchMaestra} // Refresh data after updating
        />
      </div>

      <div className="maestra-tabs">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "info" ? "active" : ""}`}
              onClick={() => setActiveTab("info")}
              href="#info"
            >
              <BsFillPersonLinesFill />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "laboral" ? "active" : ""}`}
              onClick={() => setActiveTab("laboral")}
              href="#laboral"
            >
              <MdWork />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "programas" ? "active" : ""}`}
              onClick={() => setActiveTab("programas")}
              href="#programas"
            >
              <HiMiniAcademicCap />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "comments" ? "active" : ""}`}
              onClick={() => setActiveTab("comments")}
              href="#comments"
            >
              <GoCommentDiscussion />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "documents" ? "active" : ""}`}
              onClick={() => setActiveTab("documents")}
              href="#documents"
            >
              <SlDocs />
            </a>
          </li>
        </ul>

        <div className="tab-content">
          {activeTab === "info" && <SeccionGeneral maestra={maestraData} />}
          {activeTab === "laboral" && (
            <SeccionLaboral maestra={maestraData} onSecUpdate={fetchMaestra} />
          )}
          {activeTab === "programas" && (
            <SeccionProgramas
              cursosList={maestraData.cursos_list}
              actividadesList={maestraData.actividades_list}
            />
          )}
          {activeTab === "documents" && (
            <SeccionDocumentos maestraRut={maestra.rut} />
          )}
          {activeTab === "comments" && (
            <SeccionComentarios maestraRut={maestra.rut} />
          )}
        </div>
      </div>
      <Modal show={showWhatsappModal} onHide={closeWhatsappModal} centered>
  <Modal.Header closeButton={!savingWhatsappGroups}>
    <Modal.Title>Editar grupos de WhatsApp</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {whatsappError && (
      <div className="aprobaciones-error">{whatsappError}</div>
    )}

    {allWhatsappGroups.length === 0 ? (
      <div className="text-muted">No WhatsApp groups available.</div>
    ) : (
      <div className="aprobaciones-list">
        {allWhatsappGroups.map((g) => (
          <div key={g.id} className="aprobaciones-row">
            <Form.Check
              type="checkbox"
              id={`wg-${g.id}`}
              checked={selectedGroupIds.has(g.id)}
              onChange={() => toggleWhatsappGroup(g.id)}
              disabled={savingWhatsappGroups}
              label={
                <span className="aprobaciones-label">
                  <strong>{g.nombre}</strong>
                </span>
              }
            />
          </div>
        ))}
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={closeWhatsappModal} disabled={savingWhatsappGroups}>
      Cancelar
    </Button>
    <Button variant="primary" onClick={saveWhatsappGroups} disabled={savingWhatsappGroups}>
      {savingWhatsappGroups ? "Guardando..." : "Guardar Cambios"}
    </Button>
  </Modal.Footer>
</Modal>
    </div>
  );
}

export default MaestraView;
